export const PUBLIC_ROUTE = {
  LOGIN: '/',
  SSO: '/sso/:company',
  PASSWORD_RESET: '/password-reset',
  OIDC_LOGIN: '/okta-login',
  WIDGET: '/widget',
  TOKEN_LOGIN: '/TOKEN_LOGIN',
  // ENGG-9844 — the anonymous survey respondent page. Public by design: no
  // login, no Tangelo account, and no Apollo client (see publicSurveyApi).
  PUBLIC_SURVEY: '/s/:token',
  // ENGG-8024 — a Public Page where anyone with the link creates their own
  // employee profile. Public by design, like PUBLIC_SURVEY.
  PUBLIC_EMPLOYEE_FORM: '/join/:token',
}

// ENGG-9844 — is this page the anonymous respondent's, rather than an admin's?
//
// Checked against the raw pathname because it gates things that run BEFORE
// routing: Sentry is configured at module load and FullStory mounts outside the
// router. A respondent always arrives at /s/<token> as a fresh page load, so the
// pathname at boot is the right signal.
export const isPublicSurveyPath = (pathname: string): boolean =>
  pathname === '/s' || pathname.startsWith('/s/')

// ENGG-8024 — the public employee sign-up page. Checked at boot for the same
// reason as isPublicSurveyPath: people type personal details there, so session
// recording must be off before the router runs.
export const isPublicEmployeeFormPath = (pathname: string): boolean =>
  pathname === '/join' || pathname.startsWith('/join/')

// ENGG-9844 / ENGG-8024 — may this page be recorded or sent to a session or
// analytics tool? Not the anonymous survey page nor the public sign-up page.
// App.tsx (Sentry replay, FullStory) and utils/mixpanel.ts share this one rule.
export const isRecordingAllowed = (pathname: string): boolean =>
  !isPublicSurveyPath(pathname) && !isPublicEmployeeFormPath(pathname)
